import type { WindowWithAdSense } from '@gumtree/shared/src/types/window';

import { createTracking, TextAdConditions } from '../../util/text-ads-util';
import { sendGa4Impression } from '../send-ga4-impression';
import { AdSenseSlotDivNames } from '../ad-slots';

const desktopStyleId = '8681725653';
const mobileStyleId = '4591008367';

const hideContainerIfEmpty = (window: Window, containerId: string) => {
    const el = window.document.getElementById(containerId);
    if (!el) {
        return;
    }
    el.style.display = 'none';
};

const waitForCMP = (window: Window, timeoutMs = 10000): Promise<boolean> => {
    return new Promise((resolve) => {
        const done = (ok: boolean) => resolve(ok);
        const timeout = window.setTimeout(() => done(false), timeoutMs);

        // IAB TCF
        const tcfapi = (window as unknown as { __tcfapi?: Function }).__tcfapi;
        if (typeof tcfapi === 'function') {
            try {
                tcfapi('getTCData', 2, (tcData, success) => {
                    if (!success || !tcData) return;
                    const status = tcData.eventStatus;
                    // console.log('tcfapi getTCData------', status)
                    if (status === 'tcloaded' || status === 'cmpuishown' || status === 'useractioncomplete') {
                        clearTimeout(timeout);
                        done(true);
                    }
                });

                tcfapi('addEventListener', 2, (tcData: any, success: boolean) => {
                    // console.log('tcfapi ------', tcData, success)
                    if (!success || !tcData) return;
                    const status = tcData.eventStatus;
                    if (status === 'tcloaded' || status === 'cmpuishown' || status === 'useractioncomplete') {
                        clearTimeout(timeout);
                        done(true);
                    }
                });
            } catch (_e) {
                // fall through to OneTrust
                console.log(_e)
            }
        }

        // OneTrust
        const oneTrust = (window as unknown as { OneTrust?: { OnConsentReady?: Function } }).OneTrust;
        if (oneTrust?.OnConsentReady) {
            console.log('oneTrust ------', oneTrust)
            oneTrust.OnConsentReady(() => {
                clearTimeout(timeout);
                done(true);
            });
        }

        // No CMP detected
        // done(false);
    });
};

export const loadAdSenseAds = async ({
    slot,
    pageType,
    l1Category,
    currentPage,
    device,
    isZeroResults,
    isQA,
    query,
    window,
}: TextAdConditions & {
    window: WindowWithAdSense;
    isZeroResults: boolean;
    isQA: boolean;
    query: string;
    slot: string;
}) => {
    let fallbackTimer;
    const channel = createTracking({
        pageType,
        l1Category,
        currentPage,
        device,
        isZeroResults,
        onlyToCategory: true,
    })

    const pageOptions = {
        pubId: 'partner-pub-8646360968412482',
        query,
        styleId: device === 'mobile' ? mobileStyleId : desktopStyleId,
        linkTarget: '_blank',
        adtest: isQA ? 'on' : 'off',
        channel,
        // channel: 2883204274,
        relatedSearches: 0,
        // maxTermLength: 4,
        // "adsafe": "medium",
        "adsafe": "medium",
        adLoadedCallback: function (containerName: string, adsLoaded: boolean) {
            // console.log('adLoadedCallback ------', containerName, adsLoaded)
            sendGa4Impression({
                adType: 'Adsense',
                containerName,
                adsLoaded,
                window,
            });

            if(fallbackTimer) {
                clearTimeout(fallbackTimer);
            }

            if (!adsLoaded) {
                // Hide the failed container to avoid blank space
                hideContainerIfEmpty(window as unknown as Window, containerName);
            }
        },
    };

    // Unit level parameters
    const adblock1 = {
        "container": AdSenseSlotDivNames.afscontainer1,
        // maxTop: 2,
        // number: 2,
    };

    // console.log('start load 1------', window._googCsa)
    // const pageOptions1 = {
    //   "pubId": "partner-pub-8646360968412482",
    //   "query": "dress",
    //   "adtest": "on",
    //   "styleId": "8681725653",
    //   "adsafe": "medium"
    // }
    // Ensure CMP consent before requesting ads
    await waitForCMP(window as unknown as Window, 10000);
    // console.log('cmpReady ------', cmpReady)

    window._googCsa('ads', pageOptions, adblock1);

    // Fallback：when adLoadedCallback not trigger
    fallbackTimer = window.setTimeout(() => {
        hideContainerIfEmpty(window as unknown as Window, slot)
        console.log('setTimeout ------ hideContainerIfEmpty')
    }, 10000);
};
